exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nselect[data-v-626d95c6] {\n  margin-top: 8px;\n}\n.localization-dropdown[data-v-626d95c6] {\n  position: absolute;\n  right: 8%;\n  top: 35px;\n  text-align: right;\n}\n", "", {"version":3,"sources":["/opt/build/repo/src/components/LocaleSwitcher.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,kBAAkB;CACnB","file":"LocaleSwitcher.vue","sourcesContent":["\nselect[data-v-626d95c6] {\n  margin-top: 8px;\n}\n.localization-dropdown[data-v-626d95c6] {\n  position: absolute;\n  right: 8%;\n  top: 35px;\n  text-align: right;\n}\n"],"sourceRoot":""}]);

// exports
